import { Box, styled } from "@mui/material";

export const StyledDashBoardCard = styled(Box)(({ theme }) => ({
  width: "20rem",
  height: "10rem",
  border: `3px solid ${theme.contrast.lighter}`,
  borderRadius: "15px",
  boxSizing: "border-box",
  padding: ".5rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  ".title": {
    fontWeight: "bold",
    color: theme.color.main,
    textAlign: "center",
  },
  ".amount": {
    fontSize: "2rem",
    fontWeight: "bold",
    color: theme.contrast.dark,
  },
  ".comparison": {
    color: theme.palette.success.main,
  },
  ".negative": {
    color: theme.palette.error.main,
  },
  ".compareText": {
    color: theme.contrast.main,
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    width: "16rem",
    ".title": {
      fontSize: "1.5rem",
    },
    ".amount": {
      fontSize: "1.5rem",
    },
  },
}));
